<template>
  <div
    v-show="products.length && items.length"
    class="minicart--cart-upsell-wrapper"
  >
    <div class="minicart minicart--cart-upsell">
      <h6
        class="h6 upsell-minicart__title"
        v-html="strings.title"
      />

      <vue-flickity
        ref="upsells"
        :key="products"
        :options="{
          'prevNextButtons': true,
          'pageDots': false,
          'cellAlign': 'left',
        }"
      >
        <div
          v-for="item in products"
          :key="item.id"
          class="upsell-minicart__item flex"
        >
          <a
            class="upsell-minicart-item__image cart-item__image"
            :class="{ 'cart-item__image--png': item.image.includes('.png') }"
            :href="item.url"
          >
            <img
              :src="item.image"
              alt="free-gift-image"
              width="92"
              height="92"
            >
          </a>
          <div class="upsell-minicart-item__text">
            <h6 class="upsell-minicart-item__title">
              <a :href="item.url">{{ item.title }}</a>
            </h6>
            <p class="upsell-minicart-item__price font-semibold">
              {{ price(item) }}
            </p>
            <button
              class="upsell-minicart__add-cta btn btn--white btn--border-black w-full"
              @click="addItemToCart(item)"
            >
              Add
            </button>
          </div>
        </div>
      </vue-flickity>
    </div>
  </div>
</template>

<script>
import {productPrice} from '../helpers/product'
import {useCartStore} from '../pinia/CartStore'
import {mapState, mapActions} from 'pinia'
import vueFlickity from 'vue-flickity'

export default {
  components: {
    vueFlickity
  },
  props: {},
  data() {
    return {
      strings: {...window.theme.cart.strings, ...window.theme.upsellMinicart.strings},
      products: []
    }
  },
  computed: {
    ...mapState(useCartStore, [
      'items'
    ])
  },
  watch: {
    items: function () {
      this.fetchProducts()
    }
  },
  mounted() {
    this.fetchProducts()
    this.watchTimeout = setTimeout(() => false, 1)
  },
  updated() {
    this.$nextTick(() => this.$refs.upsells.rerender())
  },
  methods: {
    ...mapActions(useCartStore, [
      'addItems'
    ]),
    payload(item) {
      return {
        items: [
          {
            id: item.id,
            quantity: 1
          }
        ]
      }
    },
    async fetchProducts() {
      clearTimeout(this.watchTimeout)
      this.watchTimeout = setTimeout(async () => {
        this.products = []
        
        if (!this.items.length) {
          return
        }

        // Use products from the collection defined in theme settings
        this.products = window.theme.upsellMinicart.collectionProducts || []
      }, 2000) // limit refresh to avoid flicker
    },
    defaultVariant(item) {
      return item.id
    },
    imageUrl(item) {
      // Use the direct image URL from the collection data
      return item.image
    },
    price(item) {
      return productPrice(item.price)
    },
    title(item) {
      return item.title
    },
    url(item) {
      return item.url
    },
    async addItemToCart(item) {
      await this.addItems(this.payload(item))
    },
  }
}
</script>
